<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import conFitossanitaria from '@/src/components/con-fitossanitaria.vue'
import { mask } from 'vue-the-mask'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

import moment from 'moment'
moment.locale('pt-br')

/**
 * Consulta fitossanitaria
 */
export default {
  directives: { mask },
  components: {
    Layout,
    Loading,
    conFitossanitaria,
    DatePicker,
  },
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    formatDate(date) {
      if (date != undefined) return moment.utc(date).format('DD/MM/YYYY')

      return '-'
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Consultas Fitossanitárias</div>
            <div class="subTitulo"
              >Consultas fitossanitárias na base de agrotóxicos registrados, a partir do produto ou cultura.</div
            >
          </div>         
        </div>
        <con-fitossanitaria />
      </div>

      <div class="borda"></div>
    </div>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Dancing+Script');
.sig3 {
  font-family: 'Dancing Script';
  font-size: 1.9em;
}
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>